module.exports = __webpack_public_path__ + "static/project-3-3ecb2aabc4a73081e873a42cfa8e8916.jpg";